// 泰语
export default {
  'SLModal.default.okText': 'เสร็จสมบูรณ์',
  'SLModal.default.cacelText': 'ยกเลิก',
  'SLModal.info.okText': 'รับทราบ',
  'SLPopconfirm.cancelText': 'ยกเลิก',
  'SLPopconfirm.okText': 'ตกลง',
  'SLModal.danger.okText': 'ลบ',
  'SLUpload.default.image.addImage': 'เพิ่มรูปภาพ',
  'SLUpload.default.image.restImages': 'ดูภาพที่เหลือ {{len}} ภาพ',
  'SLUpload.default.image.loading': 'กำลังอัปโหลด...',
  'SLUpload.default.image.fail': 'การอัปโหลดล้มเหลว โปรดลองอีกครั้ง',
  'SLUpload.default.image.delete.title': 'ยืนยันที่จะลบหรือไม่',
  'SLUpload.default.image.delete.content': 'หลังจากลบแล้วไม่สามารถกู้คืนได้',
  'SLUpload.ALTFormModal.placeholder': 'โปรดป้อนคุณลักษณะ ALT ของรูปภาพ',
  'SLUpload.ALTFormModal.tip': 'การแก้ไขคุณลักษณะ ALT ของรูปภาพช่วยเพิ่มประสิทธิภาพกลไกค้นหา (SEO) และความบกพร่องทางสายตา',
  'SLUpload.ALTFormModal.title': 'แก้ไขคุณลักษณะ ALT ของรูปภาพ',
  'SLUpload.ALTFormModal.length': 'มากที่สุดต้องไม่เกิน {{max}} อักขระ',
  'SLUpload.uploadfile.fail': 'การอัปโหลดล้มเหลว',
  'SLUpload.uploadfile.fail1': 'รูปแบบไฟล์ผิดพลาด',
  'SLUpload.uploadfile.sucess': 'อัปโหลดเรียบร้อยแล้ว',
  'SLUpload.uploadfile.text1': 'อัปโหลดไฟล์',
  'SLUpload.uploadfile.text2': '',
  'SLUpload.uploadfile.progress': 'กำลังอัปโหลด...',
  'SLUpload.dragUploading': 'ปล่อยเมาส์เพื่ออัปโหลด',
  'SLUpload.default.image.description': 'ขนาดที่แนะนำ 256 x 116',
  'SLUpload.default.image.fail.title': '{{fileName}} อัปโหลดล้มเหลว',
  'SLUpload.default.image.fail.desc1': 'ขนาดไม่เกิน {{max}}MB',
  'SLUpload.default.image.fail.desc2': 'ชื่อการอัปโหลดต้องไม่เกิน {{max}} อักขระ',
  'SLUpload.default.image.fail.desc3': 'ไฟล์มีความละเอียดสูงสุด {{limitPx}}MP โปรดลดความละเอียดแล้วลองอีกครั้ง',
  'SLUpload.default.image.fail.desc4': 'ขออภัย! คุณสามารถอัปโหลดได้ไม่เกิน {{maxNum}} ภาพ!',
  'SLUpload.uploadField.errorMsg4': 'ไม่สามารถอัปโหลดรูปภาพ',
  'SLUpload.uploadField.upload': 'อัปโหลดภาพ',
  'SLUpload.SLImage.preview.closeText': 'ปิด'
};